<script setup lang="ts">
/**
 * Layout administration : même chrome applicatif que `default`
 * (header, footer, toolbox), avec une coquille de page homogène.
 * Largeur unique pour toutes les pages /admin - ne pas recontraindre dans les pages.
 */
import DefaultLayout from '~/layouts/default.vue'
</script>

<template>
  <DefaultLayout>
    <div class="admin-layout">
      <slot />
    </div>
  </DefaultLayout>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/elpdl/spacing" as *;

/* Coquille unique : toutes les pages admin occupent la même largeur. */
.admin-layout {
  width: 100%;
  max-width: min(93.75rem, calc(100vw - 3rem)); /* 1500px / gouttières 24px×2 */
  margin-inline: auto;
  padding-bottom: $spacing-3xl;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: $spacing-xl;
}

/* La page (enfant direct) remplit toujours la coquille. */
.admin-layout > :deep(*) {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
</style>
